// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionStringForm.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Database Configuration component
 */
!(function () {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var EventsUtils = require('EventUtils');

  var DropDown = require('share/components/controls/Izenda.DropDown');

  var ConnectionStringBuilder = require('share/components/controls/connectionStringBuilder/Izenda.ConnectionStringBuilder');
  var LicenseCheckerConstants = require('logic/data/Izenda.LicenseCheckerConstants');

  var Validator = require('share/components/hoc/Izenda.Validator');
  var ValidatableSecuredInput = Validator()(require('share/components/controls/Izenda.SecuredInput'));
  const { merge, partial } = require('lodash/fp');

  var ConnectionStringForm = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    render: function () {
      var store = this.props.store;

      var databaseConfiguration = store.databaseConfiguration;
      var connectionInfo = databaseConfiguration.connectionInfo;
      var validatedConnection = databaseConfiguration.validatedConnection;
      var validConnection = databaseConfiguration.isValidConnection;

      var notifyChange = EventsUtils.notifyChange;
      var notify = EventsUtils.notify;
      var localization = this.props.localization;

      return (
          <fieldset className='row'>
            <div className='col-md-3'>{renderDataServerType.bind(this)()}</div>
            <div className='col-md-9'>{renderConnectString.bind(this)()}</div>
          </fieldset>
      );

      function renderDataServerType() {
        var serverTypeItemConfig = {
          key: 'id',
          value: 'name'
        };

        function changeDataServerType (e) {
          this.props.validation.reset();
          databaseConfiguration.updateServerType(e.value);
        }

        return (
            <div className='form-group'>
              <label className='validation required'>{localization.getText("LICENSE_CHECKER_LABEL_DATA_SERVER_TYPE")}</label>
              <DropDown options={databaseConfiguration.supportedDatabaseType || []}
                            labelField='name'
                            valueField='id'
                            value={connectionInfo.serverTypeId}
                            onChange={changeDataServerType.bind(this)}
                            ref='dbServerType' />
            </div>
          );
      };

      function renderConnectString() {
        var localization = this.props.localization;
        var connetionStringVals =  merge(LicenseCheckerConstants.CONNECTION_STRING_CONSTRAINT,
        {
          action: function () {
            return store.testConnection.bind(store);
          }
        }, {});

        return (
          <div className='form-group'>
            {/* title*/}
            <label className='control-label validation required'>{localization.getText("LICENSE_CHECKER_LABEL_CONNECTION_STRING")}</label>

            {/* connection builder*/}
            <a className='connection-builder pull-right'
               onClick={this.showConnectionStringBuilder}>
              {localization.getText("LICENSE_CHECKER_LABEL_CONNECTION_BUILDER")}
              <i className="icon-flash" />
            </a>

            <ValidatableSecuredInput
                  className='form-control'
                  onReset={notify( partial(databaseConfiguration.updateConnectionString.bind(databaseConfiguration), ''))}
                  onFocus={this.onFocus}
                  onChange={notifyChange(databaseConfiguration.updateConnectionString.bind(databaseConfiguration), EventsUtils.INPUT)}
                  value={connectionInfo.connectionString}
                  secure={validatedConnection}
                  validations={connetionStringVals}
                  field='connectionString'
                  maxLength='500'/>
          </div>
          );
      };
    },

    onFocus: function () {
      this.props.validation.reset();
    },

    showConnectionStringBuilder: function (e) {
      e.preventDefault();
      var model = this.props.store.databaseConfiguration;

      this.props.openPopup(ConnectionStringBuilder, {
        onOk: applyConnectionString.bind(this),
        serverType: this.props.store.databaseConfiguration.serverTypeName
      });

      function applyConnectionString(connectionString) {
        this.props.validation.reset();
        model.updateConnectionString(connectionString);
        return true;
      };
    }

  });

  module.exports = connect()(ConnectionStringForm);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/LicenseChecker/Izenda.ConnectionStringForm.jsx